import RichtextGroupModal from './../../../shared/widgets/richtextgroup/RichtextGroupModal';
import DeleteButton from './../../widgets/richtextgroup/DeleteButton';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { merge } from 'editor/core/highcharts-editor';
import { cloneDeep } from 'lodash';
import { setAction } from './../../../redux/actions/projectConfig';

const GlobalModal = () => {
  const {
    richtextGroupOptions,
    themeOptions,
    customizedOptions,
    aggregatedOptions: agg
  } = useSelector((state: RootState) => state.projectConfig);
  const { type } = useSelector((state: RootState) => state.layoutEditorPage);

  const dispatch = useDispatch();

  let aggregatedOptions = agg as any;
  if (type !== 'chart') {
    aggregatedOptions = merge(cloneDeep(themeOptions.options), cloneDeep(customizedOptions), null, {});
  }

  const set = (params: any) => dispatch(setAction(params));

  const closeDimmer = () => {
    set({
      richtextGroupOptions: false
    });
  };

  return (
    <>
      {richtextGroupOptions && <div className="dimmer opacity-0" onClick={closeDimmer} />}
      <RichtextGroupModal aggregatedOptions={aggregatedOptions} />
      <DeleteButton />
      <div className="highed-annotation-help-container bg-ev-navy-blue-2 text-white z-[10002]">
        <div className="highed-annotation-help-text text-white">
          Click anywhere on the chart to add an annotation to it.
        </div>
      </div>
    </>
  );
};

export default GlobalModal;
